import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2cf95c16&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=2cf95c16&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf95c16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/98-prod-frontend-deploy-tke/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cf95c16')) {
      api.createRecord('2cf95c16', component.options)
    } else {
      api.reload('2cf95c16', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2cf95c16&scoped=true&", function () {
      api.rerender('2cf95c16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/contentCenter/newMall/goodsStatistics/index.vue"
export default component.exports